import type { Components } from '@mui/material/styles';

export default function MuiSpeedDialAction(): Components['MuiSpeedDialAction'] {
  return {};
}
